(() => {
  if(customElements.get('oc-sticky-cart'))return;
  customElements.define('oc-sticky-cart',class extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();
      this.config=JSON.parse(this.querySelector('script').textContent);
      this.root=document.getElementById('MainProduct-'+this.dataset.section);
      if(!this.root)return;
      this.button=this.querySelector('button');
      this.panel=document.createElement('div');this.panel.className='oc-sticky-cart';this.panel.hidden=true;
      this.panel.dataset.devices=this.dataset.devices;this.panel.style.cssText=this.style.cssText;
      this.panel.append(this.button);document.body.append(this.panel);
      const options={signal:this.controller.signal};
      this.button.addEventListener('click',()=>this.activate(),options);
      window.addEventListener('scroll',()=>this.schedule(),{...options,passive:true});
      window.addEventListener('resize',()=>this.schedule(),options);
      this.root.addEventListener('change',()=>this.schedule(),options);
      this.observer=new MutationObserver(()=>this.schedule());
      this.observer.observe(this.root,{subtree:true,childList:true,attributes:true,characterData:true});
      this.drawerObserver=new MutationObserver(()=>this.schedule());
      this.drawerObserver.observe(document.body,{attributes:true,attributeFilter:['class']});
      for(const drawer of document.querySelectorAll('cart-drawer'))this.drawerObserver.observe(drawer,{attributes:true,attributeFilter:['class']});
      this.schedule();
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.drawerObserver?.disconnect();cancelAnimationFrame(this.frame);if(this.button)this.append(this.button);this.panel?.remove();}
    schedule(){if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});}
    source(){
      const qb=this.root.querySelector('oc-quantity-breaks');
      if(qb)return {qb,button:qb.querySelector('button[type="submit"]'),target:qb};
      const form=document.getElementById('product-form-'+this.dataset.section);
      return {form,button:form?.querySelector('[type="submit"]'),target:this.root.querySelector('variant-selects')||this.root.querySelector('.product-form__quantity')||form};
    }
    format(amount){
      const options={style:this.config.currencyDisplay==='none'?'decimal':'currency',currency:this.config.currency,currencyDisplay:this.config.currencyDisplay==='code'?'code':'symbol'};
      if(this.config.trimZeros&&amount%100===0){options.minimumFractionDigits=0;options.maximumFractionDigits=0;}
      return new Intl.NumberFormat(this.config.locale||'fr',options).format(amount/100);
    }
    update(){
      const source=this.source(),button=source.button;
      const rect=button?.getBoundingClientRect();
      const modal=document.body.classList.contains('overflow-hidden')||!!document.querySelector('cart-drawer.active,dialog[open]');
      const visible=!!rect&&button.getClientRects().length>0&&rect.bottom < -Number(this.config.threshold||0)&&!modal;
      if(this.panel.hidden===visible)this.panel.hidden=!visible;
      const busy=!!source.qb?.busy||button?.classList.contains('loading')||button?.getAttribute('aria-busy')==='true';
      const unavailable=!button||button.disabled||button.getAttribute('aria-disabled')==='true';
      this.button.disabled=!!busy||(this.config.action==='add'&&unavailable);
      this.button.classList.toggle('is-loading',!!busy);this.button.setAttribute('aria-busy',String(!!busy));
      let total=null;
      if(source.qb?.config){try{const offer=source.qb.offers.find(o=>String(o.id)===source.qb.querySelector('input[name="offer"]:checked')?.value);total=source.qb.getChoice(offer).total;}catch{}}
      else if(source.form){
        const id=source.form.querySelector('[name="id"]')?.value;
        // Dawn replaces the selected variant JSON when option selection changes.
        let variant;try{variant=JSON.parse(this.root.querySelector('[data-selected-variant]')?.textContent||'null');}catch{}
        if(String(variant?.id)!==String(id))variant=this.config.variants.find(v=>String(v.id)===String(id));
        const quantity=document.getElementById('Quantity-'+this.dataset.section);
        if(variant)total=variant.price*(Number(quantity?.value)||1);
      }
      if(this.nativeAttempt&&!busy){const error=this.root.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');if(error?.textContent.trim()){this.nativeAttempt=false;this.scrollToOptions(source);}}
      const label=this.config.text+(this.config.showPrice&&total!==null?' · '+this.format(total):'');
      if(this.button.querySelector('[data-label]').textContent!==label)this.button.querySelector('[data-label]').textContent=label;
    }
    scrollToOptions(source){
      const target=source.target||source.button;if(!target)return;
      window.scrollTo({top:window.scrollY+target.getBoundingClientRect().top-Number(this.config.offset||0),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      const focus=target.querySelector('select,input:not([type="hidden"]),button')||target;
      if(!focus.hasAttribute('tabindex')&&!focus.matches('input,select,button'))focus.setAttribute('tabindex','-1');
      focus.focus({preventScroll:true});
    }
    async activate(){
      const source=this.source();if(this.button.disabled)return;
      if(this.config.action==='scroll'){this.scrollToOptions(source);return;}
      if(source.qb){
        if(typeof source.qb.submit!=='function')return;
        await source.qb.submit();
        const error=source.qb.querySelector('[data-message]');if(error?.textContent)this.scrollToOptions(source);
      }else {this.nativeAttempt=true;source.button?.click();}
      this.schedule();
    }
  });
})();
